import React, { useState, useEffect } from "react";
import { Box, Stack } from "@mui/material";
import TaskAltIcon from "@mui/icons-material/TaskAlt";
import DoDisturbIcon from "@mui/icons-material/DoDisturb";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";


import { onAuthStateChanged } from "firebase/auth";
import { auth } from "../services/firebase";
import { useNavigate, useParams } from "react-router-dom";
import LikeButton from "./LikeButton";

const API_URL = process.env.REACT_APP_API_URL

const SongCard = ({ bid, creator, acceptSong, rejectSong }) => {
  const [user, setUser] = useState({});
  const { eventId } = useParams();
  const [grayTick, setgrayTick] = useState(false);


  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
      if (currentUser) {
        setUser(currentUser)
      } else {
        setUser(currentUser)
      }
    })

    return () => unsubscribe()
  }, [])

  
  const hasLikedSong = (songId) => {
    const likedSongs = getLikedSongsFromCookies(); // Retrieve the user's liked songs from cookies
    return likedSongs.includes(songId);
  }

  const increamentLikes = () => {
    const songId = bid.UID
    if (!hasLikedSong(songId)) {
      fetch(`${API_URL}/firebase/increment-song-likes`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          eventId: eventId,
          bidUID: bid.UID
        })
      })

      // Record the like in a cookie
      const likedSongs = getLikedSongsFromCookies();
      likedSongs.push(songId);
      setLikedSongsInCookies(likedSongs);
    }
  }

  const getLikedSongsFromCookies = () => {
    const likedSongsCookie = document.cookie.replace(
      /(?:(?:^|.*;\s*)likedSongs\s*=\s*([^;]*).*$)|^.*$/,
      "$1"
    );
    return likedSongsCookie ? JSON.parse(likedSongsCookie) : [];
  }

  const setLikedSongsInCookies = (likedSongs) => {
    document.cookie = `likedSongs=${JSON.stringify(likedSongs)}; expires=Fri, 31 Dec 9999 23:59:59 GMT; path=/`;
  }


  return (
    <>
    {
      bid.Accepted ? 
      <>
      {
        bid &&
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
          className=" bg-white py-3 pl-4 pr-4 rounded-2xl mt-1">
          <Box className="flex items-center gap-2">
            <button onClick={()=> {setgrayTick(!grayTick)}} className="py-2">
              <CheckCircleOutlineIcon className={grayTick === true ? "text-green-600" : "text-gray-500"} />
            </button>
            <div>
              <h4 className="text-black font-medium mb-2">{bid.Song}</h4>
              <p className="text-black">{bid.Artist}</p>
            </div>
          </Box>
          <Stack spacing={1.5} direction="row" alignItems="center">
            <p className={`font-medium ${grayTick === true ? "text-green-600" : "text-gray-500"}`}>
              {bid.Amount === 0 ? "" : `$${bid.Amount}`}
            </p>
            <LikeButton
              disabled={hasLikedSong(bid.UID)}
              increamentLikes={increamentLikes}
              likes={bid.Likes}
            />
          </Stack>
        </Stack>
      }
      </>
      :
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        className=" bg-white py-3 pl-4 pr-4 rounded-2xl mt-1 ">
        {
          bid && 
          <>
            <Box>
              <h4 className="text-black font-medium mb-2">{bid.Song}</h4>
              <p className="text-black">{bid.Artist}</p>
            </Box>
            <Stack spacing={1.5} direction="row" alignItems="center">
              <p className="text-red-900 font-medium">
                {bid.Amount === 0 ? "" : `$${bid.Amount}`}
              </p>
              <LikeButton
                disabled={hasLikedSong(bid.UID)}
                increamentLikes={increamentLikes}
                likes={bid.Likes}
              />
              { 
                user && creator === user.email && 
                <div>
                  <button onClick={() => acceptSong(bid.UID)} className="bg-[#59b972] rounded-[40px] text-[13px] sm:text-[15px] px-2 sm:px-4 h-10 tracking-widest text-black font-medium">
                    <TaskAltIcon />
                  </button>
                  <button onClick={() => rejectSong(bid.UID)} className="bg-[#DE3730] rounded-[40px] text-[13px] sm:text-[15px] px-2 sm:px-4 h-10 tracking-widest text-black font-medium">
                    <DoDisturbIcon />
                  </button>
                </div>
              }
            </Stack>
          </>
        }
        
      </Stack>
    }
    </>
  )
}

export default SongCard